import loadable from '@loadable/component';

export const CoursesListPage = loadable(/* #__LOADABLE__ */ () => import('./CoursesListPage'));
